import { RAZOR_PAY_SCRIPT_URL } from "../constants/common";

export const loadScript = (src) => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  };

export const loadRazorpayScript = async () => {
    if (typeof window.Razorpay !== "undefined") {
        return true;
    }
    const res = await loadScript(RAZOR_PAY_SCRIPT_URL);
    return res;
}